export default "__VITE_ASSET__CBsEE3yL__"